import React from "react";
import { Button, Modal } from "react-bootstrap";
import { formatCurrencyValue, decimalFormat, checkIfBranchExists } from "../../../utils";
import CurrencyInput from "react-currency-input"

import Autocomplete from "./components/AutoComplete";
import TableItems from "./components/TableItems";
import SaleResume from "./components/SaleResume";

import checkNFCeConfig from "./checkNFCeConfig";
import { saveSaleOnStorage, getSaleFromStorage, updateClientToSale } from "./helpers"

import FooterActionsPOS from "./components/FooterActionsPOS";
import POSContext from "./context"


export default class POS extends React.Component {
  constructor(props) {
    super(props);
    checkIfBranchExists()
    this.state = {
      loading: false,
      currentBranch: { branch_plan: {}, fiscal_config: {} },
      sale: { total_amount: 0, discount_value: 0, discount_type: "cash", items: [], payments: [] },
      currentObj: { error: "" },
      discount: { showModal: false },
      allowSendNFCe: false,
      modalItemWithoutFiscalData: false
    };
    this.onRemoveItem = this.onRemoveItem.bind(this);
    this._goToPayment = this._goToPayment.bind(this)
    this._onSetClient = this._onSetClient.bind(this)
    this._removeClient = this._removeClient.bind(this)
    this._onSetDiscountType = this._onSetDiscountType.bind(this)
    this._onChangeInputDiscount = this._onChangeInputDiscount.bind(this)
    this._onSetDiscount = this._onSetDiscount.bind(this)
    this._updateItemQuantity = this._updateItemQuantity.bind(this)
    this._openModalUpdateItemQuantity = this._openModalUpdateItemQuantity.bind(this)
    this._closeModalUpdateItemQuantity = this._closeModalUpdateItemQuantity.bind(this)
    this._onSetItemQuantity = this._onSetItemQuantity.bind(this)
    this._closeModalItemWithOutFiscalData = this._closeModalItemWithOutFiscalData.bind(this)
    this._onPressEnterModalQuantity = this._onPressEnterModalQuantity.bind(this)
  }
  _onSetClient(client) {
    const saleUpdated = updateClientToSale(client)
    this._setState({ sale: saleUpdated })
  }
  _removeClient() {
    const saleUpdated = updateClientToSale({}, true)
    this._setState({ sale: saleUpdated })
  }
  _onSetDiscountType(e) {
    const { name: discountType } = e.target
    const { sale } = this.state
    sale["discount_type"] = discountType
    this._setState({ sale: sale })
  }
  _onChangeInputDiscount(stringValue, doubleValue, event) {
    const { sale } = this.state
    if (doubleValue > sale.total_amount - sale.discount_value) {
      return
    }
    sale["discount_value_input"] = doubleValue
    this._setState({ sale: sale })

  }
  _onSetDiscount() {
    const { sale } = this.state

    const discount_value = sale["discount_type"] === "cash"
      ? sale.discount_value_input
      : sale.total_amount * (sale.discount_value_input / 100)

    sale["discount_value"] = decimalFormat(discount_value, 3)

    const discount = {
      showModal: false
    }
    this._setState({ sale: sale, discount })
  }
  _openModalUpdateItemQuantity(item) {
    this.setState({
      ...this, currentObj: {
        ...item,
        showModal: true,
        error: ""
      }
    })
    setTimeout(() => {
      try {
        document.getElementById("input-change-item-quantity").focus()
      } catch (error) {

      }
    }, 100)
  }
  _closeModalUpdateItemQuantity() {
    this.setState({
      ...this, currentObj: { error: "" }
    })
  }
  _onPressEnterModalQuantity(e) {
    if (e.key === "Enter") {
      this._onSetItemQuantity()
    }
  }
  _onSetItemQuantity() {
    const { sale, currentObj } = this.state
    for (let x = 0; x < sale.items.length; x++) {
      const item = sale.items[x]
      if (item.id === currentObj.id) {
        sale.items[x].quantity = currentObj.quantity
      }
    }
    this._setState({ sale: sale, })
    this.setState({ ...this, currentObj: { error: "" } })
    this._setPOSAutocompleteInputFocus()
  }
  _updateItemQuantity(maskedValue, doubleValue, event) {
    const { currentObj } = this.state
    currentObj.quantity = decimalFormat(doubleValue)
    this.setState({ ...this, currentObj })
  }
  _goToPayment() {
    window.location.href = "/pos/payment";
  }
  addItemToSale(item) {
    const { sale } = this.state

    if (this.state.allowSendNFCe) {
      let error = ""
      if (item.fiscal_data) {
        const { fiscal_data } = item
        const { ncm, cfop, template_icms } = fiscal_data
        if (!ncm.code || !cfop.code || !template_icms.csosn) {
          if (!ncm.code) {
            error += "SEM ICMS;"
          }
          if (!cfop.code) {
            error += "SEM CFOP;"
          }
          if (!template_icms.csosn) {
            error += "SEM NCM"
          }
          const currentObj = {
            name: item.sellable.name,
            error,
            id: item.id
          }
          this.setState({ ...this, currentObj, modalItemWithoutFiscalData: true })
          return
        }

      } else {
        const currentObj = {
          name: item.sellable.name,
          error: "Nenhuma informação fiscal",
          id: item.id
        }
        this.setState({ ...this, currentObj, modalItemWithoutFiscalData: true })
        return
      }
    }
    item.quantity = 1

    for (let x = 0; x < sale.items.length; x++) {
      if (sale.items[x].id === item.id) {
        sale.items[x].quantity += 1
        this._setState({ sale: sale })
        return
      }
    }
    sale
      .items
      .push({
        ...item,
        cfop: undefined
      })
    this._setState({ sale: sale })
    this._setPOSAutocompleteInputFocus()
  }
  _setPOSAutocompleteInputFocus() {
    try {
      document.getElementById("pos-search-items-autocomplete").focus()
    } catch (error) { }
  }
  _closeModalItemWithOutFiscalData() {
    this.setState({ ...this, currentObj: { error: "" }, modalItemWithoutFiscalData: false })
  }
  updateTotal() {
    setTimeout(() => {
      const { sale } = this.state
      let totalAmount = 0
      for (let x = 0; x < sale.items.length; x++) {
        const obj = sale.items[x]
        const total = (obj.sellable.price * obj.quantity).toFixed(4)
        totalAmount += decimalFormat(total, 2)
      }
      sale.total_amount = totalAmount
      saveSaleOnStorage(this.state.sale)
      this.setState({ ...this, sale })
    }, 100)
  }
  setDiscount() {
    this.setState({
      ...this,
      modalDiscountState: true,
    });
  }
  onRemoveItem(e) {
    const { id } = e.target
    let { sale } = this.state;
    sale.items = sale.items.filter(item => item.id != id)
    if (sale.items.length === 0) {
      sale = {
        "discount_value_input": 0,
        "total_amount": 0,
        "discount_value": 0,
        "paid_value": "",
        "change": "",
        "items": [],
        "payments": []
      }
    }
    sale = { sale: sale }
    this._setState(sale);
  }
  _loadStorageSale() {
    let sale = getSaleFromStorage()
    this.setState({ ...this, sale })
    this.updateTotal()
  }
  _setState(newState) {
    let { state } = this
    state = newState
    this.setState(state)
    saveSaleOnStorage(this.state.sale)
    this.updateTotal();
  }

  _checkAllowSendNFCe() {
    const allowSendNFCe = checkNFCeConfig()
    this.setState({ ...this, allowSendNFCe })
  }
  componentDidMount() {
    this._loadStorageSale()
    this._checkAllowSendNFCe()
  }

  render() {
    const discount = formatCurrencyValue(this.state.sale.discount_value)
    const subTotal = formatCurrencyValue(this.state.sale.total_amount)
    const total = formatCurrencyValue(this.state.sale.total_amount - this.state.sale.discount_value)
    return <POSContext.Provider value={this.state.sale}>
      <div className="container-fluid">
        <div className="row">
          <div className="col-12">
            <Autocomplete onClick={this.addItemToSale.bind(this)} />
            <TableItems
              onAddItems={this.addItemToSale}
              onRemoveItem={this.onRemoveItem}
              openModalDiscount={this._openModalUpdateItemQuantity}
            />
          </div>
        </div>

        <div className="row">
          <div className="col-12">
            <SaleResume
              subTotal={subTotal}
              discountValue={discount}
              totalAmount={total}
            />
          </div>
        </div>

        <FooterActionsPOS
          onSetClient={this._onSetClient}
          removeClient={this._removeClient}
          onChangeInputDiscount={this._onChangeInputDiscount}
          onSetDiscountType={this._onSetDiscountType}
          onSetDiscount={this._onSetDiscount}
        />
        <Modal
          show={this.state.currentObj.showModal}
          onHide={this._closeModalUpdateItemQuantity}>
          <Modal.Header closeButton>
            <Modal.Title>
              Modificar a quantidade do item {this.state.discount.showModal}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <CurrencyInput
              onKeyDown={this._onPressEnterModalQuantity}
              className="form-control"
              id="input-change-item-quantity"
              onChange={this._updateItemQuantity}
              value={this.state.currentObj.quantity || 0}
              decimalSeparator=","
              thousandSeparator="."
              precision="2" />
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={this._onSetItemQuantity}>
              Atualizar
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
      <Modal show={this.state.modalItemWithoutFiscalData} size="lg" onHide={this._closeModalItemWithOutFiscalData}>
        <Modal.Header closeButton>
          <Modal.Title>
            Item sem informações fiscais
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p className="lead">O item "{this.state.currentObj.name}" não possui informações como:</p>
          <ul className="list-group">
            {
              this.state.currentObj.error.split(";").map((error, index) => {
                const key = `modal-pos-error-item-without-fiscal-data-${error}-${index}`
                return <li
                  key={key}
                  className="list-group-item">
                  <div className="badge badge-primary">{error}</div>
                </li>
              })
            }
          </ul>
          <p>
            clique <a href={`/product/${this.state.currentObj.id}`}>aqui</a> para editar o item
          </p>
        </Modal.Body>
      </Modal>
    </POSContext.Provider>
  }
}



// WEBPACK FOOTER //
// ./src/views/AppViews/POS/index.jsx